import '../Events.js'

NS("Web");

Web.Ping = Static(Events, {
    timer: null,
    period: 60000,

    start: function() {
        var self = this;

        if (this.timer) {
            this.stop();
        }

        this.timer = setInterval(function() {
            self.run();
        }, this.period);
    },

    stop: function() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    },

    run: function() {
        var self = this;

        Xhr.call('web/ping', null, function (result) {
            var context = application.security.context;

            if (!result.success) {
                self.emit("failed");
            } else if (context.user && result.data != context.user.id) {
                self.emit("logout");
            }
        });
    }
});
